import $ from 'jquery/src/jquery';

export default () => {
    const nodeSelectors = {
        container: '[js-site-about="container"]',
        popupOpener: '[js-site-about="opener"]',
        closePopup: '[js-site-about="close"]',

        formPopupOpener: '[js-site-about="form-opener"]',
        formClosePopup: '[js-site-about="form-close"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        initAbout()
    }

    function initAbout() {
        $(nodeSelectors.popupOpener).on('click', function(){
            $('.popup-wrapper').fadeIn().css('display', 'flex');
            $('.popup-wrapper .popup .team-name').text($(this).data('title'))
            $('.popup-wrapper .popup .team-description').html($(this).data('description'))
        })

        // Close when clicking outside the popup
        $(".popup-wrapper").on("click", function(e){
            if ($(e.target).is(".popup-wrapper")) {
                $(this).fadeOut();
            }
        });

        // Close with button
        $(nodeSelectors.closePopup).on("click", function(){
            $(".popup-wrapper").fadeOut();
        });


        
        $(nodeSelectors.formPopupOpener).on('click', function(){
            $(this).parent().parent().parent().parent().find('.form-popup-holder').fadeIn().css('display', 'flex');
        })
        
        $(".form-popup-holder").on("click", function(e){
            if ($(e.target).is(".form-popup-holder")) {
                $(this).fadeOut();
            }
        });

        $(nodeSelectors.formClosePopup).on("click", function(){
            $(".form-popup-holder").fadeOut();
        });

        
    }

    return Object.freeze({
        init,
    })
}